module.exports = __webpack_public_path__ + "b0cd34bb445fd9136d9da18a84a04cae.pdf";